"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("./models");
// Actions
function addFlashMessage(flashMessage) {
    return { type: models_1.ADD_MESSAGE, flashMessage };
}
exports.addFlashMessage = addFlashMessage;
function removeFlashMessage(flashMessageId) {
    return { type: models_1.REMOVE_MESSAGE, flashMessageId };
}
exports.removeFlashMessage = removeFlashMessage;
exports.initialState = {
    messages: [],
};
exports.flashMessage = (state = exports.initialState, action) => {
    switch (action.type) {
        case models_1.ADD_MESSAGE: {
            const messages = [...state.messages, action.flashMessage];
            return Object.assign({}, state, { messages });
        }
        case models_1.REMOVE_MESSAGE: {
            const flashMessageId = action.flashMessageId;
            const messages = state.messages.filter(f => flashMessageId !== f.id);
            return Object.assign({}, state, { messages });
        }
        default: {
            return state;
        }
    }
};
